import axios from 'axios'
import Utils from '@/common/utils'

const url = `${process.env.VUE_APP_BASE_API}/api`
const headers = { Authorization: Utils.setLocalToken() }

export default class PermissionService {
  static async list (params) {
    const { data } = await axios.get(`${url}/permission`, { headers, params })
    return data?.data
  }
}
